import { iconUrl, palette } from "src/global";
import './style.scss';


export default function LoadingOverlay(params) {
    return (
        <div className="loading-overlay">
          <img src={params?.iconSrc || iconUrl} alt="loading" className="" />
          { params?.content && <span className="loading-content">{params?.content || 'Cargando...'}</span> }
          <div className="dots">
            {(params?.paletteColor || palette).map((c,i) => (<span key={i} className="" style={{ backgroundColor: c }}/>))}
          </div>
        </div>
      )
}